import { Link } from 'react-router-dom'

import Logo from './img/logo.svg'
import './navlogo.scss'

const NavLogo = () => {
	return (
		<div id="a__navLogo" className="">
			<Link to="/" className={`navbar-brand`}>
				<img src={Logo} alt="ES" width="64px" height="70px" />
			</Link>
		</div>
	)
}
export default NavLogo
